import { IApplicationState } from '../../types/redux';

export const selectTopic = (state: IApplicationState) => state.topic;
